// Billing snapshot - consolidated dashboard payload.
// Backed by GET /v1/billing/snapshot (see api/billing/management.py).
const action = "BILLING_SNAPSHOT";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

// payload: optional { workspace_id } - scopes the per-workspace blocks
// (limits, usage, meters, ai_usage) to one workspace. Every quota except
// seats/workspaces is a per-workspace allowance; balance/plan/tiers stay
// account-wide. When omitted the API falls back to the X-WORKSPACE-ID
// header (the active workspace).
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()          => ({ type: CLEAR });
